// extracted by mini-css-extract-plugin
export default {"container":"E9_2G","aspect-ratio1":"zklOO","aspect-ratio1_4":"fH4Xu"};